import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=bf3e13b2&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=bf3e13b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3e13b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf3e13b2')) {
      api.createRecord('bf3e13b2', component.options)
    } else {
      api.reload('bf3e13b2', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=bf3e13b2&scoped=true&", function () {
      api.rerender('bf3e13b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gpx4je7FWs50/JS/comp/SearchFilterTokens.vue"
export default component.exports